import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  hover: {
    '&:hover': {
      opacity: 0.9
    }
  },
  title: {
    lineHeight: '1.2rem'
  },
  desc: {
    marginTop: 5,
    fontSize: '0.9rem',
    color: theme.palette.text.primary
  },
  blogTitle: {
    fontWeight: 700,
    color: '#000000',
    fontSize: '3rem',
    padding: '20px 0'
  },
  pageTitle: {
    textAlign: 'left',
    marginTop: 15
  },
  gridContainer: {
    flexDirection: 'row-reverse',
    position: 'relative'
  },
  widget: {
    marginTop: 95
  },
  goldWidget: {
    position: 'sticky',
    top: 0
  },
  search: {
    marginBottom: 15,
    [theme.breakpoints.up('lg')]: {
      top: 40,
      right: 37,
      width: 346,
      position: 'absolute'
    }
  },
  searchInput: {
    [theme.breakpoints.down('md')]: {
      width: '100%'
    },
    [theme.breakpoints.only('md')]: {
      width: '50%'
    }
  },
  content: {
    '& img': {
      maxWidth: '100%',
      height: 'auto'
    }
  },
  image: {
    '& img': {
      width: '100%'
    }
  }
}));
